/* useEffectiveShowNoValueEntries.ts */

/* React-Redux */
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

/* Hooks */
import { useIsCustomCohortActive } from "src/utils/hooks/useIsCustomCohortActive";

/**
 * The descriptive-statistics "show no-value entries" toggle, gated by
 * custom-cohort state.
 *
 * The raw `showNoValueEntries` slice value is user state that persists even
 * after a custom cohort is selected - the toggle is only disabled visually. A
 * custom cohort has no well-defined completeness denominator, so no-value
 * entries must be treated as off there. Every consumer (the page, the chart
 * renderers, the stats panel and the legend) must read this single derived
 * value so the request, data, chart, labels and legend never disagree.
 */
export const useEffectiveShowNoValueEntries = (): boolean => {
  const showNoValueEntries = useSelector(
    (state: RootState) =>
      state.descriptiveStatisticsOptions.showNoValueEntries
  );
  const isCustomCohortActive = useIsCustomCohortActive();

  return showNoValueEntries && !isCustomCohortActive;
};
